import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDownloads = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check authentication
        const isAuth = localStorage.getItem('adminAuth');
        if (!isAuth) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminAuth');
        navigate('/admin/login');
    };

    const handleDownload = () => {
        window.location.href = 'http://api.ecommercetn.me/apps/modatex.apk';
    };

    return (
        <div className="min-h-screen bg-gray-100 py-12 px-4">
            <div className="max-w-2xl mx-auto">
                {/* Header */}
                <div className="bg-white p-6 shadow-sm mb-8 flex items-center justify-between">
                    <div>
                        <h1 className="text-3xl font-light text-gray-900 mb-1">Modatex</h1>
                        <p className="text-sm text-gray-600 uppercase tracking-wider">Application Mobile</p>
                    </div>
                    <button
                        onClick={handleLogout}
                        className="px-6 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors text-sm font-medium"
                    >
                        Déconnexion
                    </button>
                </div>

                {/* Android App */}
                <div className="bg-white p-8 shadow-sm hover:shadow-md transition-shadow">
                    <div className="text-center mb-6">
                        <div className="w-24 h-24 mx-auto mb-4 bg-gray-900 rounded-2xl flex items-center justify-center">
                            <span className="text-4xl font-light text-white">M</span>
                        </div>
                        <h3 className="text-2xl font-semibold text-gray-900 mb-2">Modatex Android</h3>
                        <p className="text-sm text-gray-600 mb-1">Fichier APK</p>
                        <p className="text-xs text-gray-500">Version 1.0.0</p>
                    </div>
                    
                    <button
                        onClick={handleDownload}
                        className="w-full bg-gray-900 text-white py-4 font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2 text-lg"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        Télécharger l'APK
                    </button>
                    
                    <div className="mt-6 p-4 bg-gray-50 text-sm text-gray-600">
                        <p className="mb-3 font-medium">Installation:</p>
                        <ol className="list-decimal list-inside space-y-2">
                            <li>Activer "Sources inconnues" dans les paramètres Android</li>
                            <li>Télécharger et ouvrir le fichier APK</li>
                            <li>Suivre les instructions d'installation</li>
                        </ol>
                    </div>
                </div>

                {/* Info Section */}
                <div className="mt-8 bg-white p-6 shadow-sm">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Mises à jour automatiques</h2>
                    <p className="text-sm text-gray-600 mb-4">
                        L'application est automatiquement reconstruite et déployée lorsque du code est poussé sur la branche principale. 
                        La dernière version est toujours disponible ici.
                    </p>
                    <div className="flex items-center gap-2 text-xs text-gray-500">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <span>Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDownloads;
